import { render, staticRenderFns } from "./SendAll.vue?vue&type=template&id=2e1a2444"
import script from "./SendAll.vue?vue&type=script&lang=js"
export * from "./SendAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports